/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { AbstractResourceService } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import {
  ETransportNotificationStatusMeta,
  ETransportNotificationViewVoModel,
} from '@well/delivery-libs/etransport/domain-model';
import { Maybe } from '@irian-ro/util-functions';

@Injectable({
  providedIn: 'root',
})
export class ETransportNotificationsListResourceService extends AbstractResourceService<
  ETransportNotificationViewVoModel,
  null,
  ETransportNotificationStatusMeta,
  null
> {
  private uploadUrl: string | undefined = undefined;

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('eTransportNotificationsListUrl'),
      ETransportNotificationViewVoModel,
      undefined,
      ETransportNotificationStatusMeta,
      undefined
    );
    this.uploadUrl = environmentService.getEnvironmentProperty('eTransportNotificationsUploadUrl');
  }

  importDefault(files: File[], shipmentUuid: Maybe<string>) {
    const formData: FormData = this.getImportFormData(files, shipmentUuid);
    return this.httpClient?.post(this.uploadUrl + `/Import Notificari ETransport`, formData);
  }

  importPersonalized(files: File[], importDefinition: string, shipmentUuid?: string) {
    const formData: FormData = this.getImportFormData(files, shipmentUuid);
    return this.httpClient?.post(this.uploadUrl + `/personalized/${importDefinition}`, formData);
  }

  private getImportFormData(files: File[], shipmentUuid: Maybe<string>): FormData{
    const formData: FormData = new FormData();
    let params: { [key: string]: string } | null = null;
    if (shipmentUuid) {
      params = {};
      params['shipment_uuid'] = shipmentUuid;
    }
    files.map((file: File) => {
      formData.append('files', file);
      formData.append('externalParams', JSON.stringify(params));
    });
    return formData;
  }

  sendDetailsEmailForCommercialPartner(notificationUuid: string) {
    return this.httpClient?.post(this.url + '/email/commercial-partner', notificationUuid);
  }

  sendDetailsEmailForShipmentOrganizer(notificationUuid: string) {
    return this.httpClient?.post(this.url + '/email/shipment-organizer', notificationUuid);
  }
}
